import { RouteLocationRaw } from 'vue-router';

import { AppRouteNames } from '@tallo/investor/navigation';
import { PropertyStatus } from '@tallo/property';

/** Where a property's card or row opens: a draft resumes its wizard, the rest go to their pages */
export function propertyRoute(property: { id: string; status: PropertyStatus }): RouteLocationRaw {
  const propertyId = property.id;

  switch (property.status) {
    case PropertyStatus.DRAFT:
      return { name: AppRouteNames.INVESTOR_PROPERTY_ONBOARDING_OVERVIEW, params: { propertyId } };

    case PropertyStatus.READY_FOR_LISTING:
      return { name: AppRouteNames.INVESTOR_PROPERTY_DETAILS, params: { propertyId } };

    default:
      return { name: AppRouteNames.INVESTOR_PROPERTY_DASHBOARD, params: { propertyId } };
  }
}
